import { useState, useEffect, useRef } from 'react';
import { Auth } from 'aws-amplify';
import {
  ValidateEmail,
} from '../../../shared/AccountPolicy/AccountPolicy';
import sharedHistory from '../../../shared/History';
import { withNavBar } from '../../shared/NavBar/NavBar';
import useLocalization from '../../../shared/useLocalization/useLocalization';

import './accountVerification.scss';
import { RouteNames } from '../../../shared/enums/RouteNames';
import { getQuery } from '../../../shared/pageUtilities/pageUtilities';

export const FormIds = {
  email: 'Email',
  verifyAccountBtn: 'VerifyAccount',
  cancelBtn: 'Cancel',
  code: 'code',
};

const VALID = 'valid';

const AccountVerification = () => {
  const local = useLocalization();
  const [formValid, setFormValid] = useState(false);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [accountVerificationErrorMessage, setAccountVerificationErrorMessage] = useState('');

  const [emailValidation, setEmailValidation] = useState(
    {} as IFieldValidation
  );
  const emailRef = useRef<HTMLInputElement>(null);
  const codeRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    let allValid = code.length > 0;
    allValid = allValid && ValidateEmail(email).class === VALID;
    setFormValid(allValid);
  }, [code, email]);

  const verifyAccount = async () => {
    try {
      await Auth.confirmSignUp(email, code);
      sharedHistory.push(RouteNames.Login);
    } catch(e) {
      const err = local ? local.t('accountVerification.resetError') : 'Error';
      setAccountVerificationErrorMessage(err);
    }
  };

  const validateEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue: string = event.currentTarget.value;
    const validate = ValidateEmail(newValue);
    setEmail(newValue);
    setEmailValidation(validate);
  };

  if (!local) return <></>;

  return (
    <>
      <h4 data-testid='mainTitle'>
        {local && local.t('accountVerification.title')}
      </h4>
      <div className='row'>
        <div className='col s12'>
          <div className='right'>
            <button
              aria-label={local.t('accountVerification.cancelButtonText')}
              className='btn btn-tertiary'
              onClick={() => sharedHistory.push(RouteNames.Login)}
              data-testid={FormIds.cancelBtn}
            >
              {local.t('accountVerification.cancelButtonText')}
            </button>
            <button
              aria-label={local.t('accountVerification.verifyButtonText')}
              className='btn btn-primary'
              onClick={verifyAccount}
              disabled={!formValid}
              data-testid={FormIds.verifyAccountBtn}
            >
              {local.t('accountVerification.verifyButtonText')}
            </button>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col s9'>
          <div className='row'>
            <div className='input-field col s6'>
              <input
                id={FormIds.email}
                ref={emailRef}
                aria-label={local.t('accountVerification.emailAddressLabel')}
                type='text'
                value={email}
                onChange={validateEmail}
                data-testid={FormIds.email}
                className={emailValidation.class}
              />
              <label htmlFor={FormIds.email}>
                {local.t('accountVerification.emailAddressLabel')}
              </label>
              <span
                className='helper-text'
                data-error={emailValidation.message}
              >
                {emailValidation.message}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col s9'>
          <div className='row'>
            <div className='input-field col s6'>
              <input
                id={FormIds.code}
                ref={codeRef}
                aria-label={local.t('accountVerification.codeLabel')}
                type='text'
                value={code}
                data-testid={FormIds.code}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setCode(e.target?.value || '');
                }}
              />
              <label htmlFor={FormIds.code}>
                {local.t('accountVerification.codeLabel')}
              </label>
              {accountVerificationErrorMessage.length > 0 ? (
                <div className='verification-error' data-testid='verificationError'>
                  {accountVerificationErrorMessage}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNavBar(AccountVerification);
